var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendario(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1362 5.17505H34.9315V7.76254H38.8128V36.225H2.58783V7.76254H6.46907V5.17505H2.26439C1.96196 5.1801 1.66349 5.24469 1.38602 5.36511C1.10856 5.48553 0.857531 5.65944 0.647286 5.87689C0.43704 6.09435 0.271693 6.35109 0.160687 6.63246C0.0496814 6.91382 -0.00480752 7.2143 0.000332559 7.51673V36.4708C-0.00480752 36.7732 0.0496814 37.0737 0.160687 37.3551C0.271693 37.6364 0.43704 37.8932 0.647286 38.1106C0.857531 38.3281 1.10856 38.502 1.38602 38.6224C1.66349 38.7428 1.96196 38.8074 2.26439 38.8125H39.1362C39.4386 38.8074 39.7371 38.7428 40.0146 38.6224C40.292 38.502 40.543 38.3281 40.7533 38.1106C40.9635 37.8932 41.1289 37.6364 41.2399 37.3551C41.3509 37.0737 41.4054 36.7732 41.4002 36.4708V7.51673C41.4054 7.2143 41.3509 6.91382 41.2399 6.63246C41.1289 6.35109 40.9635 6.09435 40.7533 5.87689C40.543 5.65944 40.292 5.48553 40.0146 5.36511C39.7371 5.24469 39.4386 5.1801 39.1362 5.17505Z",
    fill: "#0F2554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76282 15.525H10.3503V18.1125H7.76282V15.525Z",
    fill: "#0F2554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5253 15.525H18.1128V18.1125H15.5253V15.525Z",
    fill: "#0F2554"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2877 15.525H25.8752V18.1125H23.2877V15.525Z",
    fill: "#0F2554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0502 15.525H33.6377V18.1125H31.0502V15.525Z",
    fill: "#0F2554"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76282 21.9937H10.3503V24.5811H7.76282V21.9937Z",
    fill: "#0F2554"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5253 21.9937H18.1128V24.5811H15.5253V21.9937Z",
    fill: "#0F2554"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2877 21.9937H25.8752V24.5811H23.2877V21.9937Z",
    fill: "#0F2554"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0502 21.9937H33.6377V24.5811H31.0502V21.9937Z",
    fill: "#0F2554"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76282 28.4625H10.3503V31.05H7.76282V28.4625Z",
    fill: "#0F2554"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5253 28.4625H18.1128V31.05H15.5253V28.4625Z",
    fill: "#0F2554"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2877 28.4625H25.8752V31.05H23.2877V28.4625Z",
    fill: "#0F2554"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0502 28.4625H33.6377V31.05H31.0502V28.4625Z",
    fill: "#0F2554"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3503 10.35C10.6934 10.35 11.0225 10.2137 11.2651 9.97105C11.5077 9.72842 11.644 9.39935 11.644 9.05623V1.29375C11.644 0.950624 11.5077 0.621554 11.2651 0.37893C11.0225 0.136305 10.6934 0 10.3503 0C10.0071 0 9.67807 0.136305 9.43545 0.37893C9.19282 0.621554 9.05652 0.950624 9.05652 1.29375V9.05623C9.05652 9.39935 9.19282 9.72842 9.43545 9.97105C9.67807 10.2137 10.0071 10.35 10.3503 10.35Z",
    fill: "#0F2554"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0502 10.35C31.3933 10.35 31.7224 10.2137 31.965 9.97105C32.2077 9.72842 32.344 9.39935 32.344 9.05623V1.29375C32.344 0.950624 32.2077 0.621554 31.965 0.37893C31.7224 0.136305 31.3933 0 31.0502 0C30.7071 0 30.378 0.136305 30.1354 0.37893C29.8928 0.621554 29.7565 0.950624 29.7565 1.29375V9.05623C29.7565 9.39935 29.8928 9.72842 30.1354 9.97105C30.378 10.2137 30.7071 10.35 31.0502 10.35Z",
    fill: "#0F2554"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2316 5.17505H27.169V7.76254H14.2316V5.17505Z",
    fill: "#0F2554"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendario);
export default __webpack_public_path__ + "static/media/calendario.e27fb3e50d4b33f7018bccfffb60d885.svg";
export { ForwardRef as ReactComponent };